const keyCodes = {
  UP: 38,
  DOWN: 40,
  LEFT: 37,
  RIGHT: 39,
  TAB: 9,
  ENTER: 13,
  HOME: 36,
  END: 35,
  SPACE: 32,
  ESC: 27,
};

export default keyCodes;
